module.exports = __webpack_public_path__ + "static/media/CSS_Logo_New.5c8027f4.png";